import Vue from "vue";
import App from "./App";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";
import axios from "axios";
import API_BASE from "@/config/api";

Vue.config.productionTip = false;

// 配置 axios
axios.defaults.baseURL = API_BASE; // 后端 API 地址
axios.defaults.headers.post["Content-Type"] = "application/json"; // 默认发送 JSON 格式的请求体

Vue.prototype.$axios = axios; // 将 axios 挂载到 Vue 实例上

AOS.init({
  duration: 700, // 动画持续时间（毫秒）
  easing: "ease-in-out", // 动画缓动效果
  once: false, // 动画是否仅触发一次
  offset: 50, // 触发动画的偏移量
});

new Vue({
  el: "#app",
  router,
  i18n,
  render: (h) => h(App),
  mounted() {
    AOS.refresh();
    window.addEventListener("resize", AOS.refresh);
    window.addEventListener("scroll", AOS.refresh);
  },
  beforeDestroy() {
    window.removeEventListener("resize", AOS.refresh);
    window.removeEventListener("scroll", AOS.refresh);
  },
});



// WEBPACK FOOTER //
// ./src/main.js